<template>
  <Loader :value="promises.fetch" class="project-flatfinder">
    <template #default>
      <div class="project-flatfinder__items">
        <Card
          v-for="flatfinder in item.flatfinders"
          :value="flatfinder"
          :key="flatfinder.id"
          :to="{
            name: 'project-flatfinder-edit',
            params: { project: item.id, id: flatfinder.id },
          }"
        />

        <Card
          :value="{ name: $t('createUnitSelector') }"
          :icon="['fal', 'plus']"
          @click.native="createFlatfinder"
          style="cursor: pointer"
        />

        <UpsellBanner
          v-if="item.id && !addons.includes('project:presentation')"
          :title="$t('ctaResidentialSaleUpgradeTitle')"
          :description="$t('ctaResidentialSaleUpgradeDescription')"
          :action="$t('getStarted')"
          alignment="vertical"
          @action="showProjectPresentationUpsell"
        />
      </div>
      <div class="project-flatfinder__navigation">
        <slot name="navigation" :show-save="false" />
      </div>

      <UpsellBanner
      v-if="$store.state.enums.Region.value === 'NO'"
      title="Trenger du visualiseringer?"
      action="Ta kontakt"
      @action="visualizationChat"
      class="mt-2"
    >
      <template #description>
        <span>Vi i Kvass kan hjelpe deg med visualisering av ditt prosjekt. For å få den beste enhetsvelgeren anbefaler vi at du har gode vinkler og det beste utgangspunktet. Les mer her   Bestill en uforpliktende prat</span>&nbsp;
        <a href="https://www.kvass.no/produkter/3d-visualiseringer" target="_blank">Les mer</a>
      </template>
    </UpsellBanner>
    </template>
  </Loader>
</template>

<script>
import { i18n } from '@/i18n'
import { mapState, mapActions } from 'vuex'
import Bus from '@/bus'

import Card from '@/components/Flatfinder/Card'
import Badge from '@/components/Badge'
import UpsellBanner from '@/components/Upsell/Banner'

const meta = {
  order: 103,
  id: 'flatfinders',
  label: i18n.tc('unitSelector', 2),
  icon: ['fal', 'layer-plus'],
}

export { meta }
export default {
  data() {
    return {
      promises: {
        fetch: null,
      },
      items: [],
    }
  },
  computed: {
    ...mapState('Project', ['item']),
    addons() {
      return this.$path('item.metadata.addons') || []
    },
  },
  methods: {
    ...mapActions('Project', ['fetch']),
    createFlatfinder() {
      if (!['project:presentation', 'project:flatfinder'].some(a => this.addons.includes(a)))
        return this.showProjectPresentationUpsell()

      return this.$router.push({ name: 'project-flatfinder-create', params: { project: this.item.id } })
    },
    showProjectPresentationUpsell() {
      this.$bus.emit('pricing:show', {
        addon: 'project:presentation',
        options: { units: this.$path('item.metadata.limits.units') },
        action: () => this.addon('project:presentation'),
      })
    },
    addon(addon) {
      return this.$store
        .dispatch('Project/addon', {
          addon,
          state: true,
          project: this.item.id,
        })
        .then(() => this.addons.push(addon))
        .then(() => {
          this.$router.push({ name: 'project-flatfinder-create', params: { project: this.item.id } })
        })
    },
    visualizationChat() {
      Bus.$emit('chat', `Jeg ønsker hjelp med visualiseringer for prosjekt: ${this.item.name}`)
    },
  },
  created() {
    this.promises.fetch = this.fetch()
  },
  components: {
    Card,
    Badge,
    UpsellBanner,
  },
}
</script>

<style lang="scss">
.project-flatfinder {
  .elder-loader__element {
    background-color: transparent;
  }

  &__items {
    display: grid;
    gap: 2rem;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }

  &__item {
    position: relative;

    &-name {
      text-align: center;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 1rem;
      background-color: rgba(255, 255, 255, 0.8);
      backdrop-filter: blur(8px);
    }

    &--create {
      display: flex;
      flex-direction: column;
      aspect-ratio: 5 / 4;

      .project-flatfinder__item {
        &-name {
          background-color: transparent;
          position: initial;
          padding-top: 0;
        }

        &-icon {
          flex: 1;
          padding-block: 2rem;
        }
      }
    }
  }

  &__navigation {
    margin-top: 2rem;
    display: flex;
    justify-content: center;
    gap: 1rem;
  }
}
</style>
